import { Badge, styled } from '@mui/material';

type PaletteColor = 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';

const StyledAvatarBadge = styled(Badge)(({ theme, color }) => ({
	'& .MuiBadge-badge': {
		background: theme.palette[color as PaletteColor].contrastText,
		color: theme.palette.common.white,
		height: 'unset',
		minWidth: '8px',
		minHeight: '8px',
		padding: '4px',
	},
}));

export default StyledAvatarBadge;
